import React from 'react'
import { motion } from 'framer-motion'
import { BsGithub } from 'react-icons/bs'
import { BsLinkedin } from 'react-icons/bs'
import { GiClover } from 'react-icons/gi'
import AOS from "aos";
import "aos/dist/aos.css";

const Nav = () => {
  return (
<div>
<nav>
      <motion.div 
    animate={{ rotate: 360 }}
    transition={{ 
      duration:4,
      delay:1
  }}
  className="logo">
         <GiClover className="clover" fill = "#fff"/>
        </motion.div>
       
       <motion.ul
       initial={{ y: -1000 }}
       animate={{ y: 0 }}
       transition={{
         ease:'easeOut',
           type: "tween",
           duration: "3",
           delay: "2"
       }}>


    <li className='linked'><a
          target='_blank'
          rel='noreferrer'
          href='https://github.com/Babsbright'>
             <BsGithub fill = '#fff' className="icons" /></a>
             </li>

    <li className='linked'> <a
          target='_blank'
          rel='noreferrer'
          href='https://www.linkedin.com/in/tolulope-babatunde-25656a201/'>
            <BsLinkedin fill = '#fff' className="icons" /></a>
            </li>

    <li className='linked resume'> <a
          target='_blank'
          rel='noreferrer'
          
          href='https://drive.google.com/file/d/1rQySeUEhZcSL-fmmRLQUq2LsZTYjQHfK/view?usp=sharing'>
            RESUME</a>
            </li>
       

       </motion.ul>
     </nav>

</div>
  )
}

export default Nav